import React, { Component } from 'react';




import { apiPut, apiPost, apiGet, apiDelete } from '../../Api';
import RegionsList from './Admin_Regions_List';
import RegionsDetail from './Admin_Regions_Detail';
import AdminAPI from './AdminAPI';



export default class Admin_Regions extends Component {


  constructor(props) {
    super(props);
    this.state = {
      regions: [], // Load this from your backend

      creatingNewRegions: false,
      selectedRegionId: "",
      routeCostItems: [],
      routeCostItemsLoading: true,
      routeCostItemsError: '',
      saveError: '',

    }
  }





  componentDidMount = async () => {
    try {
      const [regions, items, itemTypes] = await Promise.all([
        AdminAPI.getRegions(),
        AdminAPI.getItems(),
        AdminAPI.getItemTypes(),
      ]);
      const stackableTypeIds = new Set((itemTypes || [])
        .filter(type => Boolean(type.isStackable ?? type.IsStackable))
        .map(type => String(type.id ?? type.Id)));
      const routeCostItems = (items || [])
        .filter(item => stackableTypeIds.has(String(item.typeId ?? item.TypeId)))
        .sort((a, b) => String(a.name ?? a.Name).localeCompare(
          String(b.name ?? b.Name),
        ));
      this.setState({ routeCostItems, routeCostItemsLoading: false });
      this.sortRegions(regions || []);
    } catch (error) {
      this.setState({
        routeCostItemsLoading: false,
        routeCostItemsError: 'Stackable items could not be loaded.',
      });
    }


  }
  sortRegions = (regions) => {
    if (!regions) {
      regions = this.state.regions;
    }

    const sortedRegions = [...regions].sort((a, b) => {
      // First sort by level
      if (a.level !== b.level) {
        return a.level - b.level;
      }
      // Then sort by name if levels are equal
      return a.name.localeCompare(b.name);
    });
    this.setState({ regions: sortedRegions });
    this.props.onRegionsChange?.(sortedRegions);
  }

  handleSelectRegion = (region) => {

    this.setState({
      selectedRegion: region,
      creatingNewRegions: false,
      selectedRegionId: region.id,
      selectedHuntingGroundId: "",
      saveError: '',
    });

  };

  handleNewRegions = () => {
    this.setState({
      creatingNewRegions: true,
      selectedRegion: {},
      selectedRegionId: ""
    });
  };


  handleCancelCreate = () => {
    this.setState({
      selectedRegion: null,
      creatingNewRegions: false,
    });
  };

  handleUpdate = async (regions) => {
    const response = await apiPut("/region", JSON.stringify(regions));
    if (response.ok) {

      this.sortRegions(await AdminAPI.getRegions());
      this.setState({ selectedRegionId: null });
    } else {
      this.setState({ saveError: await response.text() });
    }

  };

  handleDelete = async (regions) => {
    // Send delete request to your backend
    const response = await apiDelete("/region/" + regions.id);
    if (response.ok) {
      this.sortRegions(await AdminAPI.getRegions());

      this.setState({ selectedRegionId: null });
    }
  };

  handleCreate = async (regions) => {
    // Send delete request to your backend
    const response = await apiPost("/region", JSON.stringify(regions));

    if (response.ok) {
      this.sortRegions(await AdminAPI.getRegions());
      this.setState({ selectedRegionId: null });
    }
    else {
      this.setState({ saveError: await response.text() });
    }
  };
  handleSearch = (searchQuery) => {
    // Filter the regions based on search query
  };

  // getRegions = async () => {
  //   const response = await apiGet("/region");
  //   if (response.ok) {
  //     // console.log(response.json());
  //     const regions = await response.json();
  //     this.setState({ regions });
  //   }
  // };





  render() {
    const { regions, creatingNewRegions } = this.state;
    const { showItemPopup } = this.state;
    return (
      <div className="admin-settingspage">
        <RegionsList
          filter={this.props.filter}
          regions={regions}
          onSelectRegion={this.handleSelectRegion}

          onNewRegions={this.handleNewRegions}
        />



        <RegionsDetail
          creatingNewRegions={creatingNewRegions}
          regionId={this.state.selectedRegionId}
          onUpdate={this.handleUpdate}
          onDelete={this.handleDelete}
          onCreate={this.handleCreate}
          onCancelCreate={this.handleCancelCreate}
          routeCostItems={this.state.routeCostItems}
          routeCostItemsLoading={this.state.routeCostItemsLoading}
          routeCostItemsError={this.state.routeCostItemsError}
          saveError={this.state.saveError}

        />


      </div>
    );
  }
}
